<!-- page starts-->
<section class="page-wrapper gallery cf">
  <div class="latest-detail-section gallery cf">
     <div class="container">
        <div class="latest-gallery album cf" id="gallery">
           <h2 class="latest-gallery-titel">{{galleryList?.title}}<a routerLink="#"><span></span></a></h2>
           <div class="latest-gallery-detail gallery   popup-gallery cf">
              <div class="latest-gallery-box" [ngStyle]="{'background-image':'url(' + gallery?.files + ')'}" *ngFor="let gallery of galleryList?.data">
                 <a href="#">
                 </a>
                 <div class="image-box">
                    <img [src]="gallery?.files">
                    <div class="gallery-content-overlay">
                       <h3>{{gallery?.media_title}}</h3>
                       <!-- <div class="news-share-box-icon">
                          <ul class="news-share-icon">
                             <li>
                                <a href="javascript:void(0);">
                                <img src="assets/images/share-icon-white.svg" class="white-share-icon">
                                </a>
                             </li>
                          </ul>
                          <ul class="news-social-icon">
                             <li><a href="javascript:void(0);" class="fbsharelinkvideos" ><img src="assets/images/fb.svg"></a></li>
                             <li><a href="javascript:void(0);" class="lkinsharelinkvideos"><img src="assets/images/insta.svg"></a></li>
                             <li><a href="javascript:void(0);" class="twsharelinkvideos" ><img src="assets/images/twi.svg"></a></li>
                          </ul>
                       </div> -->
                    </div>
                 </div>
              </div>
              <!-- <div class="latest-gallery-box" Style="background-image:url(assets/images/02.png)">
                 <a href="#">
                 </a>
                 <div class="image-box">
                    <img src="assets/images/02.png">
                    <div class="gallery-content-overlay">
                       <h3>Coming at you</h3>
                       <div class="news-share-box-icon">
                          <ul class="news-share-icon">
                             <li>
                                <a href="javascript:void(0);">
                                <img src="assets/images/share-icon-white.svg" class="white-share-icon">
                                </a>
                             </li>
                          </ul>
                          <ul class="news-social-icon">
                             <li><a href="javascript:void(0);" class="fbsharelinkvideos" ><img src="assets/images/fb.svg"></a></li>
                             <li><a href="javascript:void(0);" class="lkinsharelinkvideos"><img src="assets/images/insta.svg"></a></li>
                             <li><a href="javascript:void(0);" class="twsharelinkvideos" ><img src="assets/images/twi.svg"></a></li>
                          </ul>
                       </div>
                    </div>
                 </div>
              </div>
              <div class="latest-gallery-box" Style="background-image:url(assets/images/03.png)">
                 <a href="#">
                 </a>
                 <div class="image-box">
                    <img src="assets/images/03.png">
                    <div class="gallery-content-overlay">
                       <h3>Coming at you</h3>
                       <div class="news-share-box-icon">
                          <ul class="news-share-icon">
                             <li>
                                <a href="javascript:void(0);">
                                <img src="assets/images/share-icon-white.svg" class="white-share-icon">
                                </a>
                             </li>
                          </ul>
                          <ul class="news-social-icon">
                             <li><a href="javascript:void(0);" class="fbsharelinkvideos" ><img src="assets/images/fb.svg"></a></li>
                             <li><a href="javascript:void(0);" class="lkinsharelinkvideos"><img src="assets/images/insta.svg"></a></li>
                             <li><a href="javascript:void(0);" class="twsharelinkvideos" ><img src="assets/images/twi.svg"></a></li>
                          </ul>
                       </div>
                    </div>
                 </div>
              </div>
              <div class="latest-gallery-box" Style="background-image:url(assets/images/04.png)">
                 <a href="#">
                 </a>
                 <div class="image-box">
                    <img src="assets/images/04.png">
                    <div class="gallery-content-overlay">
                       <h3>Coming at you</h3>
                       <div class="news-share-box-icon">
                          <ul class="news-share-icon">
                             <li>
                                <a href="javascript:void(0);">
                                <img src="assets/images/share-icon-white.svg" class="white-share-icon">
                                </a>
                             </li>
                          </ul>
                          <ul class="news-social-icon">
                             <li><a href="javascript:void(0);" class="fbsharelinkvideos" ><img src="assets/images/fb.svg"></a></li>
                             <li><a href="javascript:void(0);" class="lkinsharelinkvideos"><img src="assets/images/insta.svg"></a></li>
                             <li><a href="javascript:void(0);" class="twsharelinkvideos" ><img src="assets/images/twi.svg"></a></li>
                          </ul>
                       </div>
                    </div>
                 </div>
              </div>
              <div class="latest-gallery-box" Style="background-image:url(assets/images/clubsponsor-bg.jpg)">
                 <a href="#">
                 </a>
                 <div class="image-box">
                    <img src="assets/images/clubsponsor-bg.jpg">
                    <div class="gallery-content-overlay">
                       <h3>Coming at you</h3>
                       <div class="news-share-box-icon">
                          <ul class="news-share-icon">
                             <li>
                                <a href="javascript:void(0);">
                                <img src="assets/images/share-icon-white.svg" class="white-share-icon">
                                </a>
                             </li>
                          </ul>
                          <ul class="news-social-icon">
                             <li><a href="javascript:void(0);" class="fbsharelinkvideos" ><img src="assets/images/fb.svg"></a></li>
                             <li><a href="javascript:void(0);" class="lkinsharelinkvideos"><img src="assets/images/insta.svg"></a></li>
                             <li><a href="javascript:void(0);" class="twsharelinkvideos" ><img src="assets/images/twi.svg"></a></li>
                          </ul>
                       </div>
                    </div>
                 </div>
              </div> -->
           </div>
        </div>
        <div class="load-more" *ngIf="!galleryList_last_page">
           <button (click)="getMoreGallery()" class="btn-loadmore ">Load More</button>
        </div>
     </div>
  </div>
</section>
<!-- page ends-->